(() => {
    const strings = () => window.GalastellarStrings || {};
    const api = window.GalastellarTheme = {};

    api.buildProductFormData = (form) => {
        const data = new FormData(form);
        const scope = form.closest('.productView') || form;
        scope.querySelectorAll('.line-item-property__field [name^="properties["]').forEach(field => {
            if (field.disabled || (field.form && field.form !== form)) return;
            data.delete(field.name);
            if (field.type === 'file') {
                if (field.files?.length && field.files[0].size > 0) data.set(field.name, field.files[0]);
            } else if (field.value?.trim()) {
                data.set(field.name, field.value.trim());
            }
        });
        for (const [name, value] of [...data.entries()]) {
            if (!name.startsWith('properties[')) continue;
            if ((typeof value === 'string' && !value.trim()) || (typeof value !== 'string' && !value.size)) data.delete(name);
        }
        return data;
    };

    api.readQuantity = (value) => {
        if (String(value).trim() === '') return null;
        const quantity = Number(value);
        return Number.isSafeInteger(quantity) && quantity >= 0 ? quantity : null;
    };

    api.announce = (text) => {
        let status = document.getElementById('gs-action-status');
        if (!status) {
            status = document.createElement('div');
            status.id = 'gs-action-status';
            status.className = 'gs-action-status';
            status.setAttribute('role', 'status');
            status.setAttribute('aria-live', 'polite');
            document.body.appendChild(status);
        }
        status.textContent = text;
        status.classList.add('is-visible');
        clearTimeout(api.statusTimer);
        api.statusTimer = setTimeout(() => status.classList.remove('is-visible'), 3500);
    };

    api.setWishlistState = (elements, saved) => {
        elements.forEach(element => {
            const action = saved ? strings().removeWishlist : strings().saveWishlist;
            element.classList.toggle('wishlist-added', saved);
            element.setAttribute('aria-pressed', String(saved));
            element.setAttribute('aria-label', action || (saved ? window.wishlist.added : window.wishlist.add));
            element.setAttribute('title', action || (saved ? window.wishlist.added : window.wishlist.add));
            if (element.tagName === 'A') element.setAttribute('role', 'button');
            element.querySelectorAll('.text, .visually-hidden').forEach(label => {
                label.textContent = saved ? window.wishlist.added : window.wishlist.add;
            });
        });
    };

    api.cartPending = 0;
    api.changeCart = (line, quantity, callback, key) => {
        api.cartPending++;
        document.body.classList.add('gs-cart-updating');
        const run = async () => {
            const body = { quantity, sections_url: window.location.pathname };
            if (typeof key === 'string' && key.includes(':')) body.id = key;
            else body.line = line;
            const response = await fetch(routes.cart_change_url, { ...fetchConfig(), body: JSON.stringify(body) });
            const cart = await response.json();
            if (!response.ok || cart.errors || cart.status >= 400) {
                throw new Error(cart.description || cart.message || cart.errors || window.cartStrings.error);
            }
            if (typeof callback === 'function') await callback(cart);
            else Shopify.onCartUpdate(cart);
            return cart;
        };
        const request = (api.cartQueue || Promise.resolve()).catch(() => {}).then(run);
        api.cartQueue = request;
        return request.catch(error => {
            document.querySelectorAll('[data-cart-quantity]').forEach(input => { input.value = input.defaultValue; });
            if (typeof showWarning === 'function') showWarning(error.message, window.warningTime);
            api.announce(strings().cartError || window.cartStrings.error);
            return null;
        }).finally(() => {
            api.cartPending--;
            if (!api.cartPending) document.body.classList.remove('gs-cart-updating');
        });
    };

    const updateQuestionLink = (link) => {
        const scope = link.closest('.productView') || document;
        const form = scope.querySelector('form[data-type="add-to-cart-form"]');
        const variant = form?.querySelector('[name="id"]')?.value;
        const url = new URL(link.dataset.productUrl, window.location.origin);
        if (variant) url.searchParams.set('variant', variant);
        const body = `${link.dataset.productTitle}\n${url.href}\n\n${link.dataset.questionPrompt}`;
        link.href = `mailto:customer@galastellar.com?subject=${encodeURIComponent(link.dataset.questionSubject)}&body=${encodeURIComponent(body)}`;
    };

    document.addEventListener('click', event => {
        const question = event.target.closest('[data-gs-product-question]');
        if (question) updateQuestionLink(question);
        const checkout = event.target.closest('#cart-checkout, #cart-sidebar-checkout, .button-checkout');
        if (!checkout) return;
        let unsaved = false;
        document.querySelectorAll('[data-cart-quantity]').forEach(input => {
            if (input.value === input.defaultValue) return;
            unsaved = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        if (api.cartPending || unsaved) {
            event.preventDefault();
            event.stopImmediatePropagation();
            api.announce(strings().cartUpdating);
        }
    }, true);

    document.addEventListener('click', event => {
        const item = event.target.closest('[data-wishlist]');
        if (item) setTimeout(() => {
            api.announce(item.classList.contains('wishlist-added') ? strings().wishlistSaved : strings().wishlistRemoved);
        }, 0);
    });

    document.addEventListener('keydown', event => {
        const control = event.target.closest('a[data-wishlist], a[data-plus-quantity-cart], a[data-minus-quantity-cart]');
        if (control && event.key === ' ') { event.preventDefault(); control.click(); }
    });

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-gs-product-question]').forEach(updateQuestionLink);
    });
})();
